import {
  addPlanEndpoint,
  copyPlanEndpoint,
  deletePlanEndpoint,
} from "./api/Plan";

export const addPlan = async planData => {
  try {
    const newPlan = planData;
    const response = await addPlanEndpoint(newPlan);
    return response;
  } catch (error) {
    throw new Error(`Error adding new plan: ${error.message}`);
  }
};

export const copyPlan = async (sourcePlanId, digitalTwinId) => {
  try {
    const response = await copyPlanEndpoint(sourcePlanId, digitalTwinId);
    return response;
  } catch (error) {
    throw new Error(`Error copying plan: ${error.message}`);
  }
};

export const deletePlan = async planId => {
  try {
    const response = await deletePlanEndpoint(planId);
    return response;
  } catch (error) {
    throw new Error(`Error deleting plan: ${error.message}`);
  }
};
